import ConversationalAiCard from "./features"
import CTASection from "../../landing/landing_home/empower"
import Footer from "../../Footer/footer"
import Navigation from "../../navigation/header"
import Hero from "../../landing/utils/hero";

const Colleges = () => {

  return (
    <>
      <Navigation />
      <Hero
        title="Your Campus, Smarter with AI"
        subtitle="Discover a new way to learn, connect, and get support — powered by intelligent conversations that understand your needs."
      />
      <ConversationalAiCard />
      <CTASection />
      <Footer />
    </>
  );
};

export default Colleges;
